export function toggleContactForm() {
    const contactForm = document.getElementById("contactForm");
    const faqSelect = document.getElementById("faq-category-select");
    if (contactForm.classList.contains("collapse")) {
        contactForm.classList.remove("collapse");
        contactForm.classList.add("show");
        faqSelect.remove();
        document.getElementById("submitContactFormBtn").disabled = false;
    } else {
        contactForm.classList.remove("show");
        contactForm.classList.add("collapse");
    }
}
